// extracted by mini-css-extract-plugin
export default {"bottomShadow":"PolicyModal_bottomShadow__8R1I8","jsonContainer":"PolicyModal_jsonContainer__LfLGe","copyButton":"PolicyModal_copyButton__I87Eg"};